import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import template from './assets/template.html';
import './assets/styles.scss';

@extendDecorator({
    template,
})
export default class ErrorCreateQuoteDg extends Backbone.Epoxy.View {
    initialize(options) {
        this.type = options.type;
        this.rootView = options.rootView;

        this.appendBanner();
        this.dialogOpen();
    }

    dialogOpen() {
        if (!this.$dialog) return;

        this.$dialog
            .correctPopupPosition()
            .dialog({
                width: 679,
                height: 440,
                autoOpen: true,
                resizable: false,
                dialogClass: 'errorCreateQuoteDg',
                modal: true,
            }).on('click', '.js-reload-page', this.reloadPageHandler.bind(this));
    }

    reloadPageHandler() {
        if (!this.type) {
            window.location.reload();
        }

        this.rootView.trigger('startSeach');
        this.$dialog.dialog('close');
    }

    appendBanner() {
        this.$dialog = $(this.template());
        $('body').append(this.$dialog);
    }
}
